<template>
  <section>
    <div class="container.is-widescreen" style="padding:18px">
      <h1 class="title" style="color:#3e8ed0">Analytics</h1>
      <h4 class="subtitle">No. of sent messages by alphabet.</h4>

      <div class="columns" style="padding-left: 14px; padding-top: 10px; padding-bottom: 15px;">
        <div style="padding-right: 20px;">
          <b-field label="Project:">
            <b-select v-model="projectId" expanded>
              <option value="all">{{ allProjectsLabel }}</option>
              <option
                v-for="(value, key) in availableProjects"
                :key="key"
                :value="value._id"
              >
                {{ value.name }}
              </option>
            </b-select>
          </b-field>
        </div>

        <div style="padding-right: 20px;">
          <b-field label="Date range:">
            <b-datepicker
              v-model="dates"
              :locale="locale"
              placeholder="Click to select..."
              icon="calendar-today"
              trap-focus
              range
            >
            </b-datepicker>
          </b-field>
        </div>

        <div style="color: white">
          <b-field label="/" class="foo">
            <b-button type="is-primary" @click="searchClicked">Search</b-button>
          </b-field>
        </div>
      </div>

      <div style="width: 40%;" v-if="showData">
        <b-table
          :data="tableData"
          :columns="columnsC"
          :bordered="isBordered"
          class="equalWidth"
        ></b-table>
      </div>

      <div>
        <div class="columns" style="padding-left: 14px; padding-top: 30px; padding-bottom: 15px;">
          <div style="padding-right: 20px;">
            <b-dropdown :triggers="['hover']" aria-role="list">
              <template #trigger>
                <b-button
                  v-if="showData"
                  label="Export data"
                  type="is-info"
                  icon-right="menu-down"
                />
              </template>

              <b-dropdown-item aria-role="listitem">
                <download-excel
                  v-if="showData"
                  :data="tableData"
                  :fields="jsonFields"
                  name="AnalyticsByAlphabet.csv"
                  type="csv"
                  :escapeCsv="falseString"
                >
                  CSV
                </download-excel>
              </b-dropdown-item>

              <b-dropdown-item aria-role="listitem">
                <download-excel
                  v-if="showData"
                  :data="tableData"
                  :fields="jsonFields"
                  name="AnalyticsByAlphabet.xls"
                >
                  Excel
                </download-excel>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import Path from '@/path/index.js'

export default {
  name: 'ByAlphabet',
 computed: {
  ...mapGetters(['allProjects', 'getRole', 'getWorkspaceId', 'getAuthHeader', 'getSessionId']),
  availableProjects () {
    return this.allProjects.filter(
      x => x.projectType === 'Send Messages' || x.projectType === 'Forward Messages'
    )
  },
  allProjectsLabel () {
    return this.getRole === 'Super Admin' ? 'All' : 'All workspace projects'
  }
},
  async created () {
    if (this.getRole !== 'Super Admin') {
      await this.fetchProjectsByWorkspaceId(this.getWorkspaceId)
    } else {
      await this.fetchProjects()
    }
  },
  mounted () {
    this.updateSession(this.getSessionId)
  },
  data () {
    return {
      falseString: false,
      tableData: null,
      showData: false,
      projectId: null,
      isBordered: true,
      dates: [],
      locale: 'en-GB',
      columnsC: [
        {
          field: 'name',
          label: 'Alphabet',
          centered: true
        },
        {
          field: 'value',
          label: 'No. of messages',
          centered: true
        }
      ],
      jsonFields: {
        Alphabet: 'name',
        'No. of messages': 'value'
      }
    }
  },
  methods: {
    ...mapActions(['fetchProjectsByWorkspaceId', 'fetchProjects', 'updateSession']),
    async searchClicked () {
      this.updateSession(this.getSessionId)

      if (this.dates.length !== 2 || this.projectId === null) {
        this.$buefy.dialog.alert({
          title: 'Error',
          message: 'Please fill in all fields.',
          confirmText: 'Ok!',
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          iconPack: 'fa'
        })
        return
      }

      const loadingComponent = this.$buefy.loading.open()

      try {
        const startDateOriginal = this.dates[0].toLocaleDateString('en-GB')
        const endDateOriginal = this.dates[1].toLocaleDateString('en-GB')

        const startDateArray = startDateOriginal.split('/')
        const endDateArray = endDateOriginal.split('/')

        const startDate = `${startDateArray[2]}-${startDateArray[1]}-${startDateArray[0]}`
        const endDate = `${endDateArray[2]}-${endDateArray[1]}-${endDateArray[0]}`

        let response

        if (this.projectId !== 'all') {
          response = await axios.post(
            Path.PATH + '/analytics/messagesByAlphabetProject/' + this.projectId,
            {
              startDate,
              endDate
            },
            {
              headers: { Authorization: this.getAuthHeader }
            }
          )
        } else {
          response = await axios.post(
            Path.PATH + '/analytics/messagesByAlphabet',
            {
              startDate,
              endDate
            },
            {
              headers: { Authorization: this.getAuthHeader }
            }
          )
        }

        this.tableData = response.data
        this.showData = true
      } catch (error) {
        this.$buefy.dialog.alert({
          title: 'Error',
          message: 'An error occured while trying to fetch data.',
          confirmText: 'Ok!',
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          iconPack: 'fa'
        })
      } finally {
        loadingComponent.close()
      }
    }
  }
}
</script>

<style>
.foo > .label { color: white }
.equalWidth {
  width: 100%;
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
}
</style>